import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import {
  ConfigIcon,
  ConfigFillIcon,
  HomeIcon,
  HomeFillIcon,
  PayIcon,
  PayFillIcon,
  SendIcon,
  SendFillIcon,
  StakingIcon,
  StakingFillIcon,
  DeleteIcon,
  InsertIcon,
  LottoIcon,
  LottoFillIcon,
  ResetIcon,
  ResetDisabledIcon,
} from '../components/customIcon'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#CE0018',
        secondary: '#e3328a',
        error: '#ff0505', //'#F65B5B',
        success: '#1EC44A',
        orange: '#ee4b0bff',
        tokenpocket: '#37a6f7',
      },
    },
  },
  icons: {
    values: {
      config: {
        component: ConfigIcon,
      },
      config_f: {
        component: ConfigFillIcon,
      },
      home: {
        component: HomeIcon,
      },
      home_f: {
        component: HomeFillIcon,
      },
      pay: {
        component: PayIcon,
      },
      pay_f: {
        component: PayFillIcon,
      },
      send: {
        component: SendIcon,
      },
      send_f: {
        component: SendFillIcon,
      },
      staking: {
        component: StakingIcon,
      },
      staking_f: {
        component: StakingFillIcon,
      },
      delete: {
        component: DeleteIcon,
      },
      insert: {
        component: InsertIcon,
      },
      lotto: {
        component: LottoIcon,
      },
      lotto_f: {
        component: LottoFillIcon,
      },
      reset: {
        component: ResetIcon,
      },
      reset_d: {
        component: ResetDisabledIcon,
      },
    },
  },
})
